import React from 'react';

type CounterProps = {
  value: number;
  max: number;
  min: number;
  step?: number;
  handleChange: (newVal: number) => void;
  className?: string;
};

const Counter = ({
  value,
  max,
  min,
  handleChange,
  step=1,
  className="",
}: CounterProps) => {

  return (
    <div className={`counter ${className}`}>
      <button
        className="c-btn-icon subtract-btn"
        disabled={value <= min}
        onClick={() => handleChange(value - step)}
      >
        <div className="c-btn__inner">
          <i className="c-btn__icon fa fa-minus" />
        </div>
      </button>

      <strong>
        {value}
      </strong>

      <button
        className="c-btn-icon add-btn"
        disabled={value >= max}
        onClick={() => handleChange(value + step)}
      >
        <div className="c-btn__inner">
          <i className="c-btn__icon fa fa-plus" />
        </div>
      </button>
    </div>
  );
};

export default Counter;